<div class="add-notes-container" appDragDropAttachment (filesDropped)="onAttachmentsDropped($event)">
  <div class="add-notes-title">Add Notes</div>

  <div class="add-note-field-wrapper" [class.error]="(error && displayError) || newNote.errors">
    <textarea
      class="add-notes-field"
      #noteField
      (blur)="onNoteFieldBlur()"
      name="new-note"
      id="new-note"
      [formControl]="newNote"
      maxlength="1000"
    ></textarea>

    <div class="add-notes-char-count" [class.count-warning]="newNote.value?.length > 800">
      {{ newNote.value?.length || 0 }}/1000 Characters remaining
    </div>
  </div>

  <div class="note-attention">Do not enter the card/account details in notes</div>

  <div class="add-attachment-title">
    Attachments ({{ attachmentsData.length }})
    <button class="attachment-icon" (click)="onAddAttachments()" [disabled]="isDisabled">
      <rkt-icon name="attachment"></rkt-icon>
    </button>
  </div>

  @if (attachmentsData.length) {
    <ng-scrollbar track="vertical" class="attachments-scroll-wrapper">
      <div class="attachment-upload-selected-container">
        @for (attachment of attachmentsData; track attachment; let i = $index) {
          <div class="uploaded-attachment-item">
            <rkt-icon class="attachment-status" name="check"></rkt-icon>
            <div class="name">{{ attachment.name ?? attachment.file?.name }}</div>
            <button (click)="onEditFileBtnClick(i)" class="attachment-action-button attachment-action-button-edit">
              <rkt-icon name="edit"></rkt-icon>
            </button>
            <button (click)="onDeleteFileBtnClick(i)" class="attachment-action-button attachment-action-button-delete">
              <rkt-icon name="trash"></rkt-icon>
            </button>
          </div>
        }
      </div>
    </ng-scrollbar>
  }

  @if (error && displayError) {
    <div class="note-add-error">{{ error }}</div>
  }

  @if (newNote.errors && newNote.errors.isEmptySpaces) {
    <div class="note-validation-error">
      {{ newNote.errors && newNote.errors.isEmptySpaces.message }}
    </div>
  }

  <div class="add-notes-buttons">
    <button
      rktButton
      btnType="tertiary"
      (click)="onAddNoteCancel()"
      title="Discard"
      [disabled]="!newNote.value?.length || isShowSpinner || newNote.errors !== null"
    >
      Discard
    </button>
    <button
      rktButton
      (click)="onAddNoteSave()"
      title="Save"
      [disabled]="newNote.invalid || !newNote.value?.length || isShowSpinner"
      class="add-entity-btn"
    >
      <rkt-icon name="save"></rkt-icon>Save
    </button>
  </div>
</div>
